// extracted by mini-css-extract-plugin
module.exports = {"noWrappedDateTime":"FormattedDateTime__noWrappedDateTime"};